import * as angular from "angular";
import {IPromise, IScope} from "angular";
import {User, UserDto} from "../../model/User";
import {CustomerServiceName, UserServiceName} from "../../../utils/names/serviceNames";
import {Customer} from "../../../customers/model/Customer";
import {CustomerService} from "../../../customer_service/service/CustomerService";
import './transfer.users.dialog.component.scss';
import {UserService} from "../../../users_service/service/user.service";
import {UserView} from "../../model/UserFilter";

interface TransferUsersDialogComponentScope extends IScope {
    cancelTransfer: () => void;
    transferUserCustomers: () => void;
    updateSelectedEmployee: (transferEmployee: UserDto) => void;
    user: UserDto;
    customers: Customer[];
    selectedUserId: number;
    showLoader: boolean;
    queryEmployee: (query: string) => IPromise<UserDto[]>;
    submitDisabled: boolean;
    transferEmployee: UserDto;
}

export class TransferUsersDialogComponent {

    public static instance = ($event,
                              user: UserDto,
                              employeeCustomers: Customer[]): angular.material.IDialogOptions => ({
        template: require('./transfer.users.dialog.component.html'),
        controller: ['$scope', '$mdDialog', 'user', 'employeeCustomers', CustomerServiceName, UserServiceName, TransferUsersDialogComponent],
        targetEvent: $event,
        clickOutsideToClose: false,
        fullscreen: true,
        multiple: true,
        parent: angular.element(document.body),
        locals: {
            user: user,
            employeeCustomers: employeeCustomers
        },
    });


    private customers: Customer[];
    private allEmployees: User[];


    constructor(private $scope: TransferUsersDialogComponentScope,
                private $mdDialog: angular.material.IDialogService,
                private user: UserDto,
                private employeeCustomers: Customer[],
                private customerService: CustomerService,
                private employeeService: UserService) {
        $scope.user = user;
        $scope.submitDisabled = true;
        $scope.updateSelectedEmployee = this.updateSelectedEmployee;
        $scope.showLoader = false;
        $scope.queryEmployee = this.queryEmployee;
        $scope.customers = employeeCustomers;
        $scope.submitDisabled = employeeCustomers.length !== 0;
        $scope.transferUserCustomers = this.transferUserCustomers;
        $scope.cancelTransfer = this.cancelTransfer;
    }

    queryEmployee = (query: string) => {
        return this.employeeService.queryEmployee({
            query: query,
            branchesIds: [],
            showDeleted: false,
            showDisabled: false,
            userIds: [],
            view: UserView.AUTOCOMPLETE
        }).then(resp => resp.data);
    };

    transferUserCustomers = () => {
        this.employeeService.transferCustomersFromUserToUser(this.user, this.$scope.transferEmployee)
    };

    cancelTransfer = () => {
        this.$mdDialog.cancel();
    };

    updateSelectedEmployee = (transferEmployee: UserDto) => {
        this.$scope.submitDisabled = !(transferEmployee != null && transferEmployee.id != null);
        this.$scope.transferEmployee = transferEmployee;
    }

}